import {httpPost} from './http.service';

const BASE_FILES_URL = 'files';

export type UploadedFileResponse = {
    url: string;
    fileName: string;
    category: string;
    mimeType: string;
    size: number;
};

function filenameForMultipartUpload(file: File, fallbackExtension: string): string {
    if (file.name?.includes('.')) {
        return file.name;
    }
    const subtype = file.type?.split('/')?.[1];
    if (subtype === 'jpeg' || subtype === 'jpg') return 'upload.jpg';
    if (subtype && subtype !== 'octet-stream') return `upload.${subtype}`;
    return `upload.${fallbackExtension}`;
}

function postFile(file: File, fallbackExtension: string): Promise<UploadedFileResponse> {
    const formData = new FormData();
    formData.append('file', file, filenameForMultipartUpload(file, fallbackExtension));
    return httpPost<UploadedFileResponse>(BASE_FILES_URL, formData);
}

export function uploadImageFile(file: File): Promise<UploadedFileResponse> {
    return postFile(file, 'png');
}

export function uploadVideoFile(file: File): Promise<UploadedFileResponse> {
    return postFile(file, 'mp4');
}
